import * as React from 'react'
import { PositionAbsolute } from './common'
import { ButtonUnstyled, ButtonTheme } from '@cloudflare/component-button'
import { Loading } from '@cloudflare/component-loading'
import { applyTheme } from '@cloudflare/style-container'
// @ts-ignore
import { IButtonProps } from '@cloudflare/component-button'

export interface IFiddleUrlBarProps {
  onChange: (value: string) => void
  onSubmit: () => void
  value: string
  isLoading?: boolean
}

export interface IFiddleUrlBarState {
  inputValue: string
}

export class FiddleUrlBar extends React.Component<
  IFiddleUrlBarProps,
  IFiddleUrlBarState
> {
  public static defaultProps: Partial<IFiddleUrlBarProps> = {
    isLoading: false,
  }

  constructor(props: IFiddleUrlBarProps, context: any) {
    super(props, context)

    this.state = {
      inputValue: this.props.value,
    }

    this.onInputChange = this.onInputChange.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.onGoBtnClick = this.onGoBtnClick.bind(this)
  }

  shouldComponentUpdate(
    nextProps: IFiddleUrlBarProps,
    nextState: IFiddleUrlBarState,
  ) {
    if (nextProps.value !== this.props.value) return true
    if (nextProps.isLoading !== this.props.isLoading) return true
    if (nextState.inputValue !== this.state.inputValue) return true
    return false
  }

  render() {
    return (
      <form
        onSubmit={this.onSubmit}
        style={{
          background: '#f7f9fa',
          borderBottom: 'solid 1px #ccc',
          padding: '0.5rem',
          position: 'relative',
        }}
      >
        <input
          onChange={this.onInputChange}
          value={this.props.value}
          type="text"
          style={{
            boxSizing: 'border-box',
            width: '100%',
            height: 'auto',
            margin: '0',
            padding: '0.3rem 0.5rem',
            fontSize: '0.8rem',
            outline: 'none',
          }}
        />
        {this.props.isLoading && (
          <PositionAbsolute right="1rem" top="0.8rem">
            <Loading />
          </PositionAbsolute>
        )}
        <PositionAbsolute right="0.5rem" top="0.5rem">
          <UrlBarButton type="primary" onClick={this.onGoBtnClick} submit>
            {this.props.value !== this.state.inputValue ? 'Go' : 'Refresh'}
          </UrlBarButton>
        </PositionAbsolute>
      </form>
    )
  }

  onInputChange(e: React.ChangeEvent<HTMLInputElement>) {
    this.props.onChange(e.target.value)
  }

  onGoBtnClick(e: MouseEvent) {
    ;(e.target as HTMLButtonElement).blur()
  }

  onSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()
    this.setState({ inputValue: this.props.value })
    this.props.onSubmit()
  }
}

export const UrlBarButton = applyTheme(ButtonUnstyled, ButtonTheme, () => ({
  paddingTop: '0.35rem',
  paddingBottom: '0.4rem',
  paddingLeft: '0.6rem',
  paddingRight: '0.6rem',
  fontSize: '0.8rem',
}))



// WEBPACK FOOTER //
// ./src/components/FiddleUrlBar.tsx